import { systemEngineEnvironment } from "services/environment/systemEngine";

import { CreateEditDatabaseInput } from "./types";
import { Database } from "./useDatabasesNames";

export const alterDatabase = async ({
  database,
  initialDatabase,
}: {
  database: CreateEditDatabaseInput;
  initialDatabase: Database;
}) => {
  if (database.description !== initialDatabase.description) {
    const descriptionSql = systemEngineEnvironment.formatter.formatQuery(
      `ALTER DATABASE "${initialDatabase.catalogName}" SET DESCRIPTION = ?`,
      [database.description]
    );
    await systemEngineEnvironment.execute(descriptionSql);
  }

  if (database.catalogName !== initialDatabase.catalogName) {
    await systemEngineEnvironment.execute(
      `ALTER DATABASE "${initialDatabase.catalogName}" RENAME TO "${database.catalogName}";`
    );
  }
};
